import React from "react";
import { Modal } from "../../../../../../../shared/Modal/Modal";
import { DateRangePicker } from "../../../../../../../shared/DateRangePicker/DateRangePicker";
import { useCurrentUserQuery } from "../../../../../../../api/queries/useUserQuery";
import styles from "./styles.module.scss";
import { Select } from "../../../../../../../shared/Select/Select";
import { Button } from "../../../../../../../shared/Button/Button";
import { DownloadIcon } from "../../../../../../../assets/Icons/DownloadIcon";
import { CircularProgress } from "../../../../../../../shared/CircularProgress/CircularProgress";
import { Input } from "../../../../../../../shared/Input/Input";
import { SearchIcon } from "../../../../../../../assets/Icons/SearchIcon";

export function Header({ isPickerDisabled, period, clinics, download, batch }) {
  const { data: user } = useCurrentUserQuery();

  return (
    <Modal.Title className={styles.root}>
      Detailed Logs
      <DateRangePicker
        size="small"
        isDisabled={isPickerDisabled}
        dateFormat={user?.dateFormat}
        onClear={period.reset}
        onChange={({ startDate, endDate }) => {
          period.update({
            from: startDate,
            to: endDate,
          });
        }}
        value={{
          startDate: period.value.from,
          endDate: period.value.to,
        }}
      />
      <Select
        size="small"
        options={clinics.options}
        value={clinics.value}
        onChange={clinics.update}
        className={styles.select}
      />
      <Input
        value={batch.value}
        onChange={(e) => batch.update(e?.target?.value)}
        placeholder="LOT# search"
        size="small"
        rightAdornment={<SearchIcon size={16} />}
      />
      <Button
        size="small"
        isDisabled={download.isLoading}
        onClick={download.initiate}
        leftAdornment={
          download.isLoading ? (
            <CircularProgress size="small" color="white" />
          ) : (
            <DownloadIcon width="16px" />
          )
        }
      >
        Download Excel
      </Button>
    </Modal.Title>
  );
}
